// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"705c6f8c","147":"1c2f90a1","618":"fdd8c8ae"}[chunkId] + ".chunk.js";
};